<div #sidebar>
  <div #topsection [ngStyle]="{ 'border-bottom': '1px solid #eee' }">
    <ng-container *ngIf="coverScrolled">
      <uni-image
        [src]="competition?.image"
        [default]="defaultImage"
        [alt]="competition?.title"
        classes="width-100 height-auto fit-cover">
      </uni-image>
    </ng-container>
    <p
      class="margin-top-6 margin-x-2 margin-bottom-0 text-center font-bold font-md sparro-grey-900">
      {{ competition?.title }}
    </p>
    <p
      class="margin-bottom-6 margin-top-0 margin-x-8 text-center font-regular font-sm sparro-grey-800">
      {{ competition?.tagline }}
    </p>
  </div>
  <div class="sidebar-comp-info-section overflow-x-overlay" (scroll)="sideBarScroll()">
    <div class="margin-bottom-4" fxLayout="column" fxLayoutAlign="center center">
      <ng-container *ngIf="isRegistrationRound">
        <uni-navigation-button
          default="Register"
          button_class="primary"
          class="margin-bottom-2"
          customClass="sidenav-button"
          (click)="goToRegistrationPage()">
        </uni-navigation-button>

        <p
          *ngIf="competition?.registration_deadline?.starting_category?.cost"
          class="font-sm sparro-grey-800 margin-0 text-center">
          <span class="font-bold sparro-grey-900">Registration starts:</span>
          {{ competition?.registration_deadline?.starting_category?.cost }} USD
        </p>
        <span class="font-sm text-center" *ngIf="competition?.hosted">
          Exclusive pass with
          <a [href]="membershipPageLink" target="_blank" class="sparro-grey-900 font-bold"
            >UNI Membership</a
          >
        </span>
      </ng-container>

      <ng-container *ngIf="isSubmissionRound">
        <uni-navigation-button
          default="Submit entry"
          button_class="secondary"
          customClass="sidenav-button"
          (click)="submitEntry()"
          class="margin-bottom-6">
        </uni-navigation-button>
      </ng-container>

      <ng-container *ngIf="isVotingRound">
        <uni-navigation-button
          default="Vote now"
          button_class="primary"
          customClass="sidenav-button"
          (click)="goToEntries()">
        </uni-navigation-button>
      </ng-container>

      <ng-container *ngIf="isResultAnnounced">
        <uni-navigation-button
          default="View result"
          button_class="primary"
          customClass="sidenav-button"
          (click)="goToEntries()">
        </uni-navigation-button>
      </ng-container>
    </div>
    <!-- <mat-divider ></mat-divider> -->

    <!-- <mat-nav-list class="width-100 margin-bottom-4">
        <div *ngFor="let module of modules; index as i" class="width-100">
          <a mat-list-item [disableRipple]="true" #navLinks class="comp-info-link margin-x-auto no-decor" (click)="!!goToNavlink(module)" [href]="module.url">
            <h2 class="font-regular font-sm" [class.active-route]="module.name == selected">{{ module.name | titlecase }} </h2>
          </a>
        </div>
      </mat-nav-list> -->
    <ng-container *ngIf="modules[1].extras.length > 1">
      <ng-container *ngTemplateOutlet="subSectionView"></ng-container>
    </ng-container>

    <mat-expansion-panel class="mat-elevation-z0 margin-bottom-1" [expanded]="true">
      <mat-expansion-panel-header style="padding: 0 12px; border-radius: unset">
        <mat-panel-title
          class="margin-0 sparro-grey-800"
          fxLayoutAlign="start center"
          fxLayoutGap="12px">
          <i class="icon-thumbnail-fill icons font-md-static"></i>
          <p class="margin-0 font-bold font-sm-static">Brief</p>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-container *ngFor="let module of modules[0].brief; index as i">
        <a
          #navLinks
          class="margin-x-auto no-decor"
          (click)="!!goToNavlink(module)"
          [href]="module.url">
          <h2
            class="font-regular font-xs-static padding-y-1 margin-x-2 margin-y-0 sparro-grey-800 section"
            [class.active-route]="module.name == selected">
            <i [class]="module.icon + ' font-md-static margin-right-2'"></i
            >{{ module.name | titlecase }}
          </h2>
        </a>
      </ng-container>
    </mat-expansion-panel>
    <ng-container *ngIf="modules[1].extras.length == 1">
      <ng-container *ngTemplateOutlet="subSectionView"></ng-container>
    </ng-container>

    <ng-container *ngIf="competition?.resources_link">
	    <a class="margin-x-auto no-decor"
		    [href]="competition.resources_link"
		    target="_blank">
		    <h2 class="margin-0 font-bold font-sm-static section sparro-grey-800">
			    <i class="icon-download-bold icons font-md-static margin-right-3"></i>
			    Additional resources
		    </h2>
	    </a>
    </ng-container>

    <ng-container *ngIf="competition.institutional_access">
      <a
        class="margin-x-auto no-decor"
        href="https://uni.xyz/about/designers/institutional-access"
        target="_blank">
        <h2 class="margin-0 font-bold font-sm-static section sparro-grey-800">
          <i class="icon-institution-fill icons font-md-static margin-right-3"></i>Institutional
          access
        </h2>
      </a>
    </ng-container>

    <ng-container>
      <a
        class="margin-x-auto no-decor"
        href="https://helpdesk.uni.xyz/en/articles/6-master-guide-to-uni-competitions-general-rules-and-guidelines"
        target="_blank">
        <h2 class="margin-0 font-bold font-sm-static section sparro-grey-800">
          <i class="icon-activities-bold icons font-md-static margin-right-3"></i>Rules & Guidelines
        </h2>
      </a>
    </ng-container>

    <ng-container>
      <a
        class="margin-x-auto no-decor"
        href="https://uni.xyz/about/business/sponsor"
        target="_blank">
        <h2 class="margin-0 font-bold font-sm-static section sparro-grey-800">
          <i class="icon-business-fill icons font-md-static margin-right-3"></i>Become a Partner
        </h2>
      </a>
    </ng-container>

    <!-- <mat-divider></mat-divider> -->
    <ng-container *ngIf="competition.disciplines?.length">
      <mat-expansion-panel class="mat-elevation-z0 margin-bottom-1">
        <mat-expansion-panel-header style="padding: 0 12px; border-radius: unset">
          <mat-panel-title
            class="margin-0 sparro-grey-800"
            fxLayoutAlign="start center"
            fxLayoutGap="12px">
            <i class="icon-discipline-fill icons font-md-static"></i>
            <p class="margin-0 font-bold font-sm-static">Explore more under</p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-container *ngFor="let discipline of competition.disciplines">
          <a
            [href]="goToTopic(discipline.slug)"
            class="no-decor section margin-x-2"
            fxLayout="row"
            fxLayoutAlign="start center">
            <ng-container *ngIf="discipline.icon; else noDisciplineIcon">
              <uni-image
                [src]="discipline.icon"
                [alt]="discipline.name"
                [height]="24"
                [width]="24"
                auxClassList="discipline-img border-radius-1">
              </uni-image>
            </ng-container>
            <ng-template #noDisciplineIcon
              ><i class="icon-discipline-1 icons font-md-static margin-right-2"></i>
            </ng-template>
            <p class="font-xs-static margin-0">{{ discipline.name }}</p>
          </a>
        </ng-container>
      </mat-expansion-panel>
    </ng-container>

    <ng-container *ngIf="competition?.tags.length > 0">
      <!-- <mat-divider class="margin-y-6"></mat-divider> -->
      <mat-expansion-panel class="mat-elevation-z0 margin-bottom-1">
        <mat-expansion-panel-header style="padding: 0 12px; border-radius: unset">
          <mat-panel-title
            class="margin-0 sparro-grey-800"
            fxLayoutAlign="start center"
            fxLayoutGap="12px">
            <i class="icon-tagset-fill icons font-md-static"></i>
            <p class="margin-0 font-bold font-sm-static">Competition tags</p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="padding-left-3 padding-right-2 padding-y-2">
          <mat-chip-list class="tags-section margin-top-4">
            <mat-chip
              *ngFor="let tag of competition?.tags"
              [selectable]="false"
              [removable]="false">
              <ng-container *ngIf="tag?.image; else iconView">
                <uni-image
                  [src]="tag.image"
                  [width]="24"
                  [height]="24"
                  classes="fit-cover border-radius-5 margin-right-1">
                </uni-image>
              </ng-container>
              <ng-template #iconView>
                <i class="icon-tag font-sm-static"></i>
              </ng-template>
              <a [href]="goToTopic(tag.slug)" class="no-decor" *ngIf="tag.slug">
                {{ tag.name }}
              </a>
              <span (click)="goToDiscipline(tag)" class="cursor-pointer" *ngIf="!tag.slug">
                {{ tag.name }}
              </span>
            </mat-chip>
            <mat-chip
              *ngFor="let typology of competition?.seo_keyword"
              [selectable]="false"
              [removable]="false">
              <i class="icon-tag font-sm-static"></i>
              <span (click)="goToDiscipline(typology)">{{ typology.name }}</span>
            </mat-chip>
          </mat-chip-list>
        </div>
      </mat-expansion-panel>
    </ng-container>
  </div>
</div>

<ng-template #subSectionView>
  <ng-container *ngFor="let module of modules[1].extras; index as i">
    <a #navLinks class="margin-x-auto no-decor" (click)="!!goToNavlink(module)" [href]="module.url">
      <h2
        class="margin-0 font-bold font-sm-static section sparro-grey-800"
        [class.active-route]="module.name == selected">
        <i [class]="module.icon + ' icons font-md-static margin-right-3'"></i
        >{{ module.name | titlecase }}
      </h2>
    </a>
  </ng-container>
</ng-template>
